import { z } from "zod";

import i18n from "@/configs/i18n";

/**
 * Markazlashtirilgan, tarjima qilingan zod xato xabarlari.
 *
 * Ilovadagi har bir forma har bir qoidaga qo'lda xabar yozmasdan turib
 * ma'noli, tarjima qilingan xato oladi ("Kamida 5 ta belgi kiriting (hozir
 * 3 ta)"). Xabarlar i18next orqali TEKSHIRUV PAYTIDA hosil qilinadi, shuning
 * uchun ular doim tanlangan tilga ergashadi.
 *
 * Sxema baribir qoidaga o'z xabarini bera oladi — maxsus xabar shu jadvaldan
 * ustun turadi.
 */

const t = (key: string, params?: Record<string, unknown>): string =>
  i18n.t(`VALIDATION.${key}`, params ?? {});

/**
 * Bo'sh maydon. `valueAsNumber` bilan ulangan bo'sh raqam maydoni `NaN`
 * beradi — u ham "to'ldirilmagan", "noto'g'ri qiymat" emas.
 */
const isBlank = (input: unknown): boolean =>
  input === undefined ||
  input === null ||
  input === "" ||
  (typeof input === "number" && Number.isNaN(input));

const lengthOf = (input: unknown): number => (typeof input === "string" ? input.length : 0);

export function setupZodErrorMap(): void {
  z.config({
    customError: issue => {
      switch (issue.code) {
        case "invalid_type":
          if (isBlank(issue.input)) return t("REQUIRED");
          // Pul maydonlari BUTUN so'mda: backend `@IsInt` bilan kasrni rad
          // etadi, shuning uchun "noto'g'ri qiymat" emas, aynan "butun son"
          // deb aytiladi — admin nimani tuzatishni biladi.
          return issue.expected === "int" ? t("INTEGER") : t("INVALID");

        case "too_small": {
          const min = Number(issue.minimum);
          if (issue.origin === "string") {
            // `min(1)` — "majburiy" ning odatiy yozilishi; soddaroq xabar ko'rsatiladi.
            if (min <= 1) return t("REQUIRED");
            return t("MIN_LENGTH", { min, current: lengthOf(issue.input) });
          }
          if (issue.origin === "array") return t("MIN_ITEMS", { min });
          return t("MIN_VALUE", { min });
        }

        case "too_big": {
          const max = Number(issue.maximum);
          if (issue.origin === "string") {
            return t("MAX_LENGTH", { max, current: lengthOf(issue.input) });
          }
          if (issue.origin === "array") return t("MAX_ITEMS", { max });
          return t("MAX_VALUE", { max });
        }

        case "invalid_format": {
          if (issue.format === "email") return t("EMAIL");
          if (issue.format === "url") return t("URL");
          return t("INVALID");
        }

        case "invalid_value":
          return t("REQUIRED");

        default:
          // undefined → zod'ning o'z standarti (yoki sxemadagi maxsus xabar)
          return undefined;
      }
    },
  });
}
